import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Download, Calendar, Gift } from 'lucide-react';
import { BuyButton } from './BuyButton';
const InlineCountdown: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState(11 * 3600 + 9 * 60 + 37);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-red-600 text-white rounded-lg p-3 text-center shadow-md border-2 border-red-700" data-id="element-123">
      <p className="text-xs font-bold uppercase tracking-wider mb-2" data-id="element-124">
        ⏰ Oferta termina en:
      </p>
      <div className="flex gap-2 justify-center items-center font-bold text-xl sm:text-2xl" data-id="element-125">
        <div className="bg-white text-red-600 rounded px-2 py-1 min-w-[42px]" data-id="element-126">
          {fmt(hours)}
        </div>
        <span data-id="element-127">:</span>
        <div className="bg-white text-red-600 rounded px-2 py-1 min-w-[42px]" data-id="element-128">
          {fmt(minutes)}
        </div>
        <span data-id="element-129">:</span>
        <div className="bg-white text-red-600 rounded px-2 py-1 min-w-[42px]" data-id="element-130">
          {fmt(seconds)}
        </div>
      </div>
      <div className="flex gap-2 justify-center text-[10px] mt-1 uppercase font-semibold opacity-90" data-id="element-131">
        <span className="min-w-[42px]" data-id="element-132">hs</span>
        <span className="w-2" data-id="element-133"></span>
        <span className="min-w-[42px]" data-id="element-134">min</span>
        <span className="w-2" data-id="element-135"></span>
        <span className="min-w-[42px]" data-id="element-136">seg</span>
      </div>
    </div>;
};
export const PurchaseSection: React.FC = () => {
  return <section id="purchase-section" className="min-h-screen flex items-center bg-offwhite px-4 sm:px-6 lg:px-8 py-8" data-id="element-137">
      <div className="max-w-2xl mx-auto w-full" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-2xl border border-lavender overflow-hidden" data-id="element-139">
          {/* Header */}
          <div className="bg-navy p-4 sm:p-6 text-center text-white" data-id="element-140">
            <h2 className="font-serif text-xl sm:text-2xl font-bold mb-1" data-id="element-141">
              Abordaje del Insomnio en Ansiedad y Depresión
            </h2>
            <p className="text-lavender-muted text-sm" data-id="element-142">
              Sistema para intervenir el sueño según el cuadro clínico del
              paciente.
            </p>
          </div>

          {/* Body */}
          <div className="p-4 sm:p-6 space-y-4" data-id="element-143">
            {/* Countdown box */}
            <InlineCountdown data-id="element-144" />

            {/* Includes list */}
            <div data-id="element-145">
              <h3 className="font-bold text-navy text-base mb-2 border-b border-gray-100 pb-1" data-id="element-146">
                Incluye:
              </h3>
              <ul className="space-y-1.5 text-gray-700 text-sm" data-id="element-147">
                <li className="flex items-center gap-2 font-semibold" data-id="element-148">
                  <div className="w-2 h-2 bg-accent rounded-full shrink-0" data-id="element-149"></div>
                  Todo el sistema Abordaje del Insomnio en Ansiedad y Depresión
                </li>
                <li className="flex items-center gap-2 text-accent font-semibold" data-id="element-150">
                  <Gift className="w-4 h-4 shrink-0" data-id="element-151" />
                  BONUS: Protocolo de Psicoeducación sobre el Sueño
                </li>
                <li className="flex items-center gap-2 text-accent font-semibold" data-id="element-152">
                  <Gift className="w-4 h-4 shrink-0" data-id="element-153" />
                  BONUS: Diario de Sueño del Paciente
                </li>
                <li className="flex items-center gap-2 text-accent font-semibold" data-id="element-154">
                  <Gift className="w-4 h-4 shrink-0" data-id="element-155" />
                  BONUS: Guía de Higiene del Sueño
                </li>
              </ul>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center" data-id="element-156">
              <BuyButton price={true} final={true} className="w-full" data-id="element-157" />
            </div>

            {/* Trust signals */}
            <div className="grid grid-cols-4 gap-2 text-[10px] sm:text-xs text-gray-600 font-medium pt-2 border-t border-gray-100" data-id="element-158">
              <div className="flex flex-col items-center text-center gap-1" data-id="element-159">
                <ShieldCheck className="w-5 h-5 text-navy" data-id="element-160" />
                <span data-id="element-161">Pago único</span>
              </div>
              <div className="flex flex-col items-center text-center gap-1" data-id="element-162">
                <Zap className="w-5 h-5 text-navy" data-id="element-163" />
                <span data-id="element-164">Acceso inmediato</span>
              </div>
              <div className="flex flex-col items-center text-center gap-1" data-id="element-165">
                <Calendar className="w-5 h-5 text-navy" data-id="element-166" />
                <span data-id="element-167">Garantía 7 días</span>
              </div>
              <div className="flex flex-col items-center text-center gap-1" data-id="element-168">
                <Download className="w-5 h-5 text-navy" data-id="element-169" />
                <span data-id="element-170">Descargable</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};